import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import Marketplace from 'pages/marketplace'
import MarketplaceDetails from 'pages/marketplace/details'
import ListPortal from 'pages/portal-tokenize'
import { PAGES } from 'routes/index'

export const marketplaceRoutes: RouteObject[] = [
  {
    path: PAGES.MARKETPLACE,
    element: (
      <PrivateRoute feature={FEATURE.MARKETPLACE}>
        <Marketplace />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.MARKETPLACE_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.MARKETPLACE}>
        <MarketplaceDetails />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.PORTAL,
    element: (
      <PrivateRoute feature={FEATURE.PORTAL_TOKENIZE}>
        <ListPortal />
      </PrivateRoute>
    ),
  },
]
